import type { ReactNode } from 'react';
import React from 'react';

import { useIsEmbed } from 'src/shared/hooks';

import { Branch } from './Branch';
import { Gtm } from './Gtm';
import { OneSignal } from './OneSignal';
import { Segment } from './Segment';
import { Split } from './Split';
import { Vwo } from './Vwo';

interface TelemetryProps {
  children: ReactNode;
}

const Telemetry = ({ children }: TelemetryProps) => {
  const isEmbed = useIsEmbed();
  if (isEmbed) {
    return (
      <>
        <Segment />
        {children}
      </>
    );
  }

  return (
    <>
      <Segment />
      <Gtm />
      <OneSignal />
      <Branch>
        <Split>{children}</Split>
      </Branch>
      <Vwo />
    </>
  );
};

export { Telemetry };
